//Library Imports
import React, { Suspense } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

//Local Imports
import ListingWrapper from "../GroupListing/ListingWrapper";
import GroupPage from "../GroupPage/GroupPage";
const ManageHeader = React.lazy(() => import("./ManageHeader"));

interface IManageWrapper {
  page: string;
  tab?: string;
  subtab?: string;
}

const ManageWrapper: React.FC<IManageWrapper> = (props) => {
  // Props
  const { page, tab } = props;

  // Local Variables
  const history = useHistory();
  const path = history.location.pathname;

  return (
    <Wrapper>
      <Suspense fallback={<div>Loading...</div>}>
        <ManageHeader page={page} tab={tab} />
      </Suspense>
      {path.endsWith("/group-list") ? <GroupPage /> : <ListingWrapper />}
    </Wrapper>
  );
};

export default ManageWrapper;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 70px 90px 0 63px;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    padding: 50px 65px 0 63px;
  }
  .content-inner {
    display: flex;
    align-self: flex-end;
    flex-direction: column;
    background-color: #fff;
    box-sizing: border-box;
    float: right;
    width: calc(100% - 88px);
    min-height: 100vh;
    background-color: #f9f8f6;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      width: calc(100% - 63px);
    }
    .automation-content-wrapper {
      display: flex;
      flex-wrap: wrap;
      margin: 135px 0px 0 0px;
      position: relative;
      scrollbar-width: thin;
      max-height: calc(100vh - 135px);
      overflow-y: auto;
      scrollbar-color: #001760 #efefef;
      &::-webkit-scrollbar {
        width: 5px;
        height: 5px;
        border-radius: 5px;
      }
      /* Track */
      &::-webkit-scrollbar-track {
        background: #fff;
      }
      /* Handle */
      &::-webkit-scrollbar-thumb {
        background: #001760;
      }
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        margin-top: 105px;
        max-height: calc(100vh - 105px);
      }
    }
  }
`;
